module.exports = "/static/assets/a3ec03e8d784da668d0957acc88b3833.png";